jQuery(function($) {

    $(document).ready(function() {

        // --- Cache DOM elements ---
        const body = document.querySelector( 'body' );
        const siteNav = document.getElementById('siteNav');
        const header = document.querySelector('.header-container');
        const navbarNavContainer = header.querySelector('.navbar-navigation');
        const offcanvasBody = document.getElementById('offcanvasNavBody');
        const languageBtn = document.getElementById('language-selector-btn');
        const languageLinks = document.getElementById('languageLinks');
        const languageDropdownParent = languageBtn ? languageBtn.parentElement : null;
        const languageOffcanvasBody = document.getElementById('languageOffcanvasBody');
        const searchBtn = document.getElementById('search-toggle-btn');
        const searchFormDropdown = document.getElementById('searchFormDropdown');
        const searchFormContainer = document.getElementById('searchFormContainer');
        const searchFormContent = document.getElementById('searchFormContent');
        const backdrop = document.getElementById('customDropdownBackdrop');
        const searchOffcanvasBody = document.getElementById('searchOffcanvasBody');
        const navLoginModalTrigger = document.querySelector('.top-nav--member-link__login a');
        const banner = document.getElementById('pif-news-alert');
        const copyButtons = document.querySelectorAll('.copy-page-link');
        const successBanner = document.getElementById('page-link-copied-success-banner');

        let inOffcanvas = false;

        // --- Move main navigation to offcanvas or header based on screen size ---
        function moveNav() {
            if (window.innerWidth < 1000) {
                if (!inOffcanvas) {
                    offcanvasBody.appendChild(siteNav);
                    inOffcanvas = true;
                }
            } else {
                if (inOffcanvas) {
                    navbarNavContainer.appendChild(siteNav);
                    inOffcanvas = false;
                }
            }
        }

        // --- Have main navigation links behave like accordion on mobile and hoverable dropdown on desktop ---
        function enableDropdownBehavior() {
            const mainMenu = document.querySelector('#menu-main-navigation');
            if (!mainMenu) return;
            const dropdowns = mainMenu.querySelectorAll('.dropdown');
            dropdowns.forEach(dropdown => {
                dropdown.onmouseenter = null;
                dropdown.onmouseleave = null;
            });

            // Remove previous delegated listener if any
            mainMenu.removeEventListener('_delegatedDropdownClick', mainMenu._dropdownHandler);

            if (window.innerWidth >= 1000) {
                dropdowns.forEach(dropdown => {
                    dropdown.onmouseenter = function() {
                        this.classList.add('show');
                        const menu = this.querySelector('.dropdown-menu');
                        if (menu) menu.classList.add('show');
                    };
                    dropdown.onmouseleave = function() {
                        this.classList.remove('show');
                        const menu = this.querySelector('.dropdown-menu');
                        if (menu) menu.classList.remove('show');
                    };
                });
            } else {
                // Delegate click event
                mainMenu._dropdownHandler = function(e) {
                    const link = e.target.closest('.nav-link');
                    if (link && link.parentElement.classList.contains('dropdown')) {
                        e.preventDefault();
                        const parent = link.parentElement;
                        parent.classList.toggle('show');
                        const menu = parent.querySelector('.dropdown-menu');
                        if (menu) menu.classList.toggle('show');
                    }
                };
                mainMenu.addEventListener('click', mainMenu._dropdownHandler);
                // Mark the event for easy removal later
                mainMenu.addEventListener('_delegatedDropdownClick', mainMenu._dropdownHandler);
            }
        }

        function enableDropdownToggleAccordion() {
            document.querySelectorAll('#menu-main-navigation .dropdown-toggle').forEach(function(toggle) {
                toggle.onclick = function(e) {
                    if (window.innerWidth < 1000) {
                        e.preventDefault();
                        const parent = this.closest('.dropdown');
                        parent.classList.toggle('show');
                        const menu = parent.querySelector('.dropdown-menu');
                        if (menu) menu.classList.toggle('show');
                    }
                };
            });
        }

        // --- Have language selector open offcanvas on mobile ---
        let languageOffcanvasInstance = null;
        function enableLanguageSelector() {
            if (!languageBtn || !languageLinks || !languageDropdownParent || !languageOffcanvasBody) return;
            if (window.innerWidth < 1000) {
                languageBtn.onclick = function(e) {
                    e.preventDefault();
                    if (!languageOffcanvasInstance) {
                        languageOffcanvasInstance = new understrap.Offcanvas(document.getElementById('languageOffcanvas'));
                    }
                    languageOffcanvasInstance.show();
                };
            } else {
                languageBtn.onclick = null;
            }
        }

        // --- Move language links to offcanvas or header based on screen size ---
        function moveLanguageLinks() {
            if (!languageBtn || !languageLinks || !languageDropdownParent || !languageOffcanvasBody) return;
            if (window.innerWidth < 1000) {
                languageOffcanvasBody.appendChild(languageLinks);
                languageLinks.style.display = 'block';
                languageBtn.removeAttribute('data-bs-toggle');
                languageBtn.setAttribute('aria-expanded', 'false');
            } else {
                languageDropdownParent.appendChild(languageLinks);
                languageLinks.style.display = '';
                languageBtn.setAttribute('data-bs-toggle', 'dropdown');
                languageBtn.setAttribute('aria-expanded', 'false');
            }
        }

        // --- Move search form to offcanvas or header based on screen size ---
        function moveSearchForm() {
            if (window.innerWidth < 1000) {
                searchOffcanvasBody.appendChild(searchFormContent);
            } else {
                searchFormContainer.appendChild(searchFormContent);
            }
        }

        // --- Hide any open offcanvas when switching to desktop ---
        function hideOffcanvasOnDesktop() {
            if (window.innerWidth >= 1000) {
                document.querySelectorAll('.offcanvas').forEach(function(canvas) {
                    const instance = understrap.Offcanvas.getInstance(canvas);
                    if (instance && canvas.classList.contains('show')) {
                        instance.hide();
                    }
                });
            }
        }

        // --- Track breakpoint ---
        let lastBreakpoint = window.innerWidth < 1000 ? 'mobile' : 'desktop';

        // --- Debounce function to limit how often a function can run (mostly used for 'resize' events listeners) ---
        function debounce(func, wait) {
            let timeout;
            return function() {
                clearTimeout(timeout);
                timeout = setTimeout(func, wait);
            };
        }

        function handleBreakpointChange() {
            const currentBreakpoint = window.innerWidth < 1000 ? 'mobile' : 'desktop';
            if (currentBreakpoint !== lastBreakpoint) {
                // Move elements immediately for minimal jank/jumpiness
                moveNav();
                moveSearchForm();
                moveLanguageLinks();
                hideOffcanvasOnDesktop();

                // Debounce non-critical UI updates
                setTimeout(() => {
                    enableDropdownBehavior();
                    enableDropdownToggleAccordion();
                    enableLanguageSelector();
                }, 0);

                lastBreakpoint = currentBreakpoint;
            }
        }

        window.addEventListener('resize', debounce(handleBreakpointChange, 100));

        // --- Initial setup to ensure proper layout ---
        moveNav();
        moveSearchForm();
        moveLanguageLinks();
        hideOffcanvasOnDesktop();
        enableDropdownBehavior();
        enableDropdownToggleAccordion();
        enableLanguageSelector();

        // --- Close all offcanvas when any "close all" button is clicked ---
        document.querySelectorAll('.offcanvas .btn-close-all').forEach(function(btn) {
            btn.onclick = function(e) {
                e.preventDefault();
                document.querySelectorAll('.offcanvas').forEach(function(canvas) {
                    const instance = understrap.Offcanvas.getInstance(canvas);
                    if (instance) instance.hide();
                });
            };
        });

        // --- Have search form open in offcanvas on mobile or a dropdown on desktop ---
        let searchOffcanvasInstance = null;
        searchBtn.onclick = function(e) {
            if (window.innerWidth >= 1000) {
                e.preventDefault();
                if (searchFormDropdown.style.display === 'block') {
                    searchFormDropdown.style.display = 'none';
                    backdrop.style.display = 'none';
                } else {
                    // open our custom backdrop and dropdown to mimic an offcanvas coming down from header
                    searchFormDropdown.style.display = 'block';
                    backdrop.style.display = 'block';
                    const input = searchFormContent.querySelector('input[type="search"]');
                    if (input) input.focus();
                }
            } else {
                e.preventDefault();
                if (!searchOffcanvasInstance) {
                    searchOffcanvasInstance = new understrap.Offcanvas(document.getElementById('searchOffcanvas'));
                }
                searchOffcanvasInstance.show();
            }
        };
        // Close the search dropdown if clicking outside of it or pressing Escape
        backdrop.addEventListener('click', function() {
            searchFormDropdown.style.display = 'none';
            backdrop.style.display = 'none';
        });
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                searchFormDropdown.style.display = 'none';
                backdrop.style.display = 'none';
            }
        });
        // Focus the search input when the offcanvas is shown
        document.getElementById('searchOffcanvas').addEventListener('shown.bs.offcanvas', function () {
            const input = document.querySelector('#searchFormContent input[type="search"]');
            if (input) input.focus();
        });
        
        // --- Close any open offcanvas when login link is clicked ---
        if (navLoginModalTrigger) {
            navLoginModalTrigger.onclick = function(e) {
                document.querySelectorAll('.offcanvas').forEach(function(canvas) {
                    const instance = understrap.Offcanvas.getInstance(canvas);
                    if (instance && canvas.classList.contains('show')) {
                        instance.hide();
                    }
                });
            };
        }

        // --- News alert banner functionality ---
        if (banner) {
            const bannerId = banner.dataset.bannerId;
            const closeBanner = banner.querySelector('.close-banner');
            const bannerLinks = banner.querySelectorAll('a');

            // Un-hide the news banner if the user hasn't hidden this banner before and set up listeners for close button and links
            if (sessionStorage.getItem( 'hiddenBannerId') !== bannerId) {
                banner.classList.remove('d-none');
                body.classList.add('has-alert-banner');

                closeBanner._handler = function(e) {
                    hideBannerOnSubsequentVisits(null);
                };
                closeBanner.addEventListener('click', closeBanner._handler);

                for (const link of bannerLinks) {
                    link._handler = function(e) {
                        e.preventDefault();
                        hideBannerOnSubsequentVisits(link.href);
                    };
                    link.addEventListener('click', link._handler);
                }
            }

            function hideBannerOnSubsequentVisits(redirectURL = null) {
                sessionStorage.setItem('hiddenBannerId', bannerId);
                body.classList.remove('has-alert-banner');
                if (redirectURL) {
                    window.location.href = redirectURL;
                }
                // Remove listeners to prevent leaks
                closeBanner.removeEventListener('click', closeBanner._handler);
                bannerLinks.forEach(link => link.removeEventListener('click', link._handler));
            }

        }

        // --- Copy page link functionality ---
        copyButtons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                body.appendChild(successBanner); // Move banner to end of body to ensure it's on top of all other elements when displayed
                navigator.clipboard.writeText(window.location.href).then(() => {
                    successBanner.classList.add('copied');
                    setTimeout(() => {
                        successBanner.classList.remove('copied');
                    }, 2000);
                }).catch(err => {
                    console.error('Failed to copy text: ', err);
                });
            });
        });

    });

});

// --- Automatically opens external <a> links in a new window/tab ( based on plugin by Kristian Risager Larsen ) ---
function external_links_in_new_windows_loop() {

    const documentLinks = document.querySelector( '#page-wrapper' ).querySelectorAll( 'a' );

    for ( let t=0; t<documentLinks.length; t++ ) {
    
        const thisLink = documentLinks[t];
        let split_href = thisLink.href.split( theme_settings.blogdomainHost );
        let is_subdomain = ( split_href[0] !== 'http://' && split_href[0] !== 'https://' ) ? false : true;

        // forced if the address starts with http (or also https), but does not link to the current domain
        // theme_settings.blogdomainHost is passed in functions.php
        if ( thisLink.href.search( /^http/ ) != -1 && !is_subdomain ) {
            
            const sameWindow = thisLink.classList.contains( 'same-window' );
            
            // add target="_blank" if <a> doesn't have the 'same-window' class 
            if ( !sameWindow ) {
                thisLink.setAttribute( 'target', '_blank' );
                thisLink.setAttribute( 'rel', 'noopener external' );
            }

        } else if ( ( location.hostname === thisLink.hostname || !thisLink.hostname.length ) && thisLink.href.search( '/wp-admin/' ) == -1 ) {
            // if it's an internal page (that doesn't include wp-admin in the href [e.g. edit links])        
        }

    }

}
// --- Load the external link function ---
function external_links_in_new_windows_load() { 
    let oldonload = window.onload;
    if ( typeof window.onload != 'function' ) {
    window.onload = external_links_in_new_windows_loop();
    } else {
    window.onload = function() {
        oldonload();
        external_links_in_new_windows_loop();
    }
    }
}
external_links_in_new_windows_load();